import classNames from "classnames";
import React, { useContext, useState } from "react";
import { RegionSelectedContext, YearSelectedType } from "../../contexts/RegionSelectedContext";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Images from "../../assets/images/Images";
import { AvailableYear, AvailableYears } from "./availableYears";

const SHOWABLE_YEARS = 4;

const YearSelectorContainer = styled.div`
  @media (min-width: 481px) {
    display: flex;
    align-items: center;
    font-family: MapfreText-ExtraBold;
    margin-bottom: 50px;
    align-items: flex-end !important;
    min-height: 110px;

    .menuOpener {
      align-items: baseline;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      font-size: 22px;
      height: 50px;
      font-family: MapfreText-ExtraBold;
    }

    .yearSelected {
      display: flex;
      margin: auto;
      font-family: MapfreText-ExtraBold;
    }

    .open-arrow {
      display: flex;
      margin: auto 20px;
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-left: 14px solid
        ${(props: { darkMode: boolean }) =>
          props.darkMode ? "black" : "white"};
      height: 0px;
    }

    .closed-arrow {
      display: flex;
      content: "";
      margin: auto 20px;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 14px solid
        ${(props: { darkMode: boolean }) =>
          props.darkMode ? "black" : "white"};
      height: 0px;
    }

    .year {
      flex: 1 1 auto;
      display: inline-block;
      padding: 11px 20px;
      margin-right: 7px;
      cursor: pointer;
      color: #e8e5e4;
      font-size: 17px;
      background-color: #464646;
      font-family: MapfreText-ExtraBold;
      transition: background-color 0.3s, color 0.3s;
    }

    .year:hover {
      background-color: #fbfbfb;
      color: #464646;
    }

    .selected {
      background-color: #fbfbfb;
      color: #464646;
    }

    .open-yearsList {
      display: flex;
      flex-direction: row;
      transition: all 0.3s ease-out, width 0.3s ease-out;
      justify-content: flex-end;
      align-items: flex-end;
      height: 50%;
    }

    .closed-yearsList {
      opacity: 0;
      overflow: hidden;
      display: none;
    }

    .yearSelectTitle {
      display: none;
    }

    .blur {
      display: none;
    }
    .yearFont {
      font-family: MapfreText-ExtraBold !important;
    }

    .downloadable {
      width: 150px;
      word-break: initial;
      padding: 5px;
      font-size: 12px;
      display: flex;
      flex-direction: row;
      font-family: MapfreText-Light !important;
    }
    .mobileContainer {
      display: flex;
    }

    .separator {
      display: none;
    }

    .yearCarrat-closed {
      display: none;
    }
    .yearCarrat-open {
      display: none;
    }
  }

  @media (max-width: 480px) {
    display: flex;
    align-items: center;
    font-family: MapfreText-ExtraBold;

    .menuOpener {
      cursor: pointer;
      font-size: 18px;
      display: flex;
      flex-direction: row;
      height: 50px;
    }

    .yearSelected {
      display: flex;
      margin: auto;
    }

    .open-arrow {
      display: none;
    }

    .closed-arrow {
      display: flex;
      content: "";
      margin: auto 10px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 8px solid
        ${(props: { darkMode: boolean }) =>
          props.darkMode ? "black" : "white"};
      height: 0px;
    }

    .yearSelectTitle {
      font-size: 20px;
      margin-bottom: 10px;
    }

    .blur {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      display: block;
      opacity: 1.5;
      width: 100%;
      height: 100%;
      background-color: black;
    }

    @supports (backdrop-filter: blur(2px)) {
      .blur {
        background-color: #00000000;
        backdrop-filter: blur(2px);
      }
    }

    .open-yearsList {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      width: 100%;

      z-index: 999;
    }

    .closed-yearsList {
      display: none;
    }

    .year {
      display: flex;
      flex-direction: column-reverse;
      max-width: 100px;
      font-family: MapfreText-ExtraBold !important;
      padding: 30px 100px;
      border-radius: 20px;
      margin-bottom: 10px;
      cursor: pointer;
      color: #e8e5e4;
      font-size: 25px;
      background-color: #464646;

      transition: all 0.3s ease-out;
    }

    .selected {
      background-color: #fbfbfb;
      color: #464646;
    }

    .downloadable {
      font-size: 12px;
      display: flex;
      flex-direction: column;
      margin-top: 20px;
    }

    .mobileContainer {
      display: flex;
      flex-direction: row;
      transition: all 0.3s ease-out;
    }

    .separator {
      height: 2px;
      border-top: 2px solid black;
      margin-bottom: 10px;
      margin-left: -100%;
      width: 300%;
    }

    .yearWrapper {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      transition: all 0.3s ease-out;
    }

    .yearCarrat-open {
      height: 20px;
      transform: rotate(-90deg);
      margin-left: 10px;
      transition: all 0.3s ease-out;
    }

    .yearCarrat-closed {
      height: 20px;
      transform: rotate(0deg);
      margin-left: 10px;
      transition: all 0.3s ease-out;
    }

    .yearFont {
      font-family: MapfreText-ExtraBold !important;
    }
  }
`;

interface YearProps {
  year: number;
  niiff: boolean;
  yearSelected: YearSelectedType;
  onClick: () => void;
}

const Year: React.FC<YearProps> = ({ year, niiff, yearSelected, onClick }) => {
  const { t, i18n } = useTranslation();
  const getCurrentLng = () =>
    i18n.language || window.localStorage.i18nextLng || "es";

  const { regionSelected, selectableYears } = useContext(RegionSelectedContext);
  const isSelectedYear = year === yearSelected.year && niiff === yearSelected.niiff;

  const lang: string = getCurrentLng();
  const downloadLink =
    selectableYears[lang as keyof typeof selectableYears].filter(
      (item) => item.year === year && regionSelected === item.region && item.niiff === niiff
    )[0] || "";

  const doDownloadLink = () => {
    if (downloadLink?.link) {
      window.open(downloadLink.link, "_blank");
    }
  };

  return (
    <div
      className={classNames("year", { selected: isSelectedYear })}
      onClick={onClick}
    >
      {isSelectedYear && downloadLink.link && (
        <div className={"downloadable"} onClick={doDownloadLink}>
          <div className={"separator"} />
          <div className={"mobileContainer"}>
            <img
              src={Images.pdf_download_black}
              style={{ height: 40, marginRight: 20 }}
              alt={t("pdf.download")}
            />
            <div>{t("pdf.download")}</div>
          </div>
        </div>
      )}
      <div className={"yearWrapper"}>
        <div className={"yearFont"}>{year + (niiff ? "\u00A0NIIF" : "")}</div>
        <img
          src={Images.expand}
          className={classNames(
            { "yearCarrat-open": isSelectedYear },
            { "yearCarrat-closed": !isSelectedYear }
          )}
          alt={t("pdf.download")}
        />
      </div>
    </div>
  );
};

const Years: React.FC<{
  yearSelectorOpened: boolean;
  setYearSelectorOpened: (d: boolean) => void;
  setShowRegion: (d: boolean) => void;
}> = ({ yearSelectorOpened, setYearSelectorOpened, setShowRegion }) => {
  const { selectableYears, yearSelected, setYearSelected, regionSelected } = useContext(
    RegionSelectedContext
  );

  const { i18n } = useTranslation();

  if (yearSelected === undefined)
    return (<></>);

  const getCurrentLng = () =>
    i18n.language || window.localStorage.i18nextLng || "es";

  const lang: keyof AvailableYears = getCurrentLng() as keyof AvailableYears;
  // @ts-ignore
  const yearsToShow = [...new Set((selectableYears[lang] as AvailableYear[])
    .filter(year => year.region === regionSelected)
    .map((obj) => JSON.stringify({ year: obj.year, niiff: obj.niiff })))]
    .map<AvailableYear>((obj) => JSON.parse(obj))
    .sort((a, b) => b.year - a.year || (+b.niiff) - (+a.niiff))
    .slice(0, SHOWABLE_YEARS)

  const onYearClick = (year: YearSelectedType) => () => {
    setYearSelectorOpened(false);
    setShowRegion(true);
    setYearSelected(year);
  };

  return (
    <>
      <div className={classNames(yearSelectorOpened ? "blur" : "")} />
      <div
        className={classNames(
          yearSelectorOpened ? "open-yearsList" : "closed-yearsList"
        )}
      >
        <div className={"yearSelectTitle"}>SELECCIONA AÑO</div>
        {yearsToShow &&
          yearsToShow.map((year) => (
            <Year
              year={year.year}
              niiff={year.niiff}
              yearSelected={yearSelected}
              onClick={onYearClick(year)}
              key={`year-${year.year}-${year.niiff}`}
            />
          ))}
      </div>
    </>
  );
};

const YearSelectorComponent: React.FC<{
  customStyle?: object;
  darkMode?: boolean;
  setShowRegion?: (a: boolean) => void;
}> = ({
  customStyle = {},
  darkMode = false,
  setShowRegion = (a = false) => {},
}) => {
  const [yearSelectorOpened, setYearSelectorOpened] = useState(false);
  const { yearSelected } = useContext(RegionSelectedContext);

  const onSelectorToggle = () => {
    setYearSelectorOpened(!yearSelectorOpened);
    setShowRegion(yearSelectorOpened);
  };

  return (
    <YearSelectorContainer
      className={classNames(yearSelectorOpened ? "open" : "closed")}
      style={{ ...customStyle }}
      darkMode={darkMode}
    >
      <div className="menuOpener" onClick={onSelectorToggle}>
        <div className="yearSelected">{yearSelected.year + (yearSelected.niiff ? "\u00A0NIIF" : "")}</div>
        <div
          className={classNames(
            yearSelectorOpened ? "open-arrow" : "closed-arrow"
          )}
        />
      </div>
      <Years
        yearSelectorOpened={yearSelectorOpened}
        setYearSelectorOpened={setYearSelectorOpened}
        setShowRegion={setShowRegion}
      />
    </YearSelectorContainer>
  );
};

export default YearSelectorComponent;
